import React from 'react';

const MenuContextual = ({
  menuContextual,
  equipo,
  posActual,
  configSuplentes,
  onTransferir,
  onIntercambiar,
  onQuitar,
  onCerrar,
  capitanIndex,
  onCapitan,
}) => {
  if (!menuContextual) return null;

  const { index, pos, esSuplente, x, y } = menuContextual;
  const jugador = equipo[index];

  const menuW = 190;
  const menuH = 220;
  const vw = window.innerWidth;
  let left = x - menuW / 2;
  let top = y - menuH - 8;
  if (left < 8) left = 8;
  if (left + menuW > vw - 8) left = vw - menuW - 8;
  if (top < 8) top = y + 80;

  return (
    <div
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
      onClick={onCerrar}
    >
      <div
        style={{
          position: 'fixed', top, left,
          background: '#0f172a', border: '1px solid #00f2ff',
          borderRadius: '12px', padding: '8px', width: menuW,
          boxShadow: '0 0 30px rgba(0,242,255,0.25)',
          animation: 'fadeInMenu 0.12s ease-out',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header con nombre del jugador */}
        {jugador && (
          <div style={{ padding: '8px 12px 10px', borderBottom: '1px solid #1e293b' }}>
            <p style={{ color: '#00f2ff', fontWeight: 'bold', margin: 0, fontSize: '0.85rem' }}>
              {jugador.apellido}
            </p>
            <p style={{ color: '#64748b', margin: 0, fontSize: '0.75rem' }}>
              {pos} · {jugador.club?.sigla}
            </p>
          </div>
        )}

        {/* Transferir */}
        <button className="menu-opcion" onClick={onTransferir}>
          🔄 Transferir
        </button>

        {/* Capitán — solo titulares (no suplentes) */}
        {!esSuplente && jugador && onCapitan && (
          <button className="menu-opcion" onClick={() => onCapitan(index)}
            style={{ color: capitanIndex === index ? '#f59e0b' : undefined }}>
            {capitanIndex === index ? '★ Quitar capitán' : '★ Nombrar capitán'}
          </button>
        )}

        {/* Intercambiar titular ↔ suplente */}
        {!esSuplente && (() => {
          const compatibles = configSuplentes.filter(s => equipo[s.id] && s.pos === pos);
          if (!compatibles.length) return null;
          return compatibles.map(s => (
            <button key={s.id} className="menu-opcion" onClick={() => onIntercambiar(index, s.id)}>
              ↕ Entrar: {equipo[s.id]?.apellido}
            </button>
          ));
        })()}

        {esSuplente && jugador && (() => {
          const compatibles = posActual
            .map((p, i) => ({ ...p, i }))
            .filter(p => p.pos === pos && equipo[p.i]);
          if (!compatibles.length) return null;
          return compatibles.map(p => (
            <button key={p.i} className="menu-opcion" onClick={() => onIntercambiar(index, p.i)}>
              ↕ Entrar por: {equipo[p.i]?.apellido}
            </button>
          ));
        })()}

        {/* Quitar */}
        {jugador && (
          <button className="menu-opcion danger" onClick={() => onQuitar(index)}>
            ✕ Quitar jugador
          </button>
        )}

        <button
          className="menu-opcion muted"
          style={{ borderTop: '1px solid #1e293b', marginTop: '4px' }}
          onClick={onCerrar}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default MenuContextual;